module.exports = __webpack_public_path__ + "img/logotipo-programando-futuro-horizontal.3a9ec8fe.svg";